import { cn } from '@/utils/cn'
import { useTheme } from '@/hooks/useTheme'
import { getSectionNavStyles, type NavSectionKey } from './navIconStyles'

interface NavIconTileProps {
  icon: React.ElementType
  sectionKey: NavSectionKey
  isActive?: boolean
  size?: 'md' | 'sm'
  /** Tooltip quando menu recolhido (repasse do label) */
  title?: string
}

/** Tile colorido 32×32 — cor da seção do menu */
export function NavIconTile({
  icon: Icon,
  sectionKey,
  isActive = false,
  size = 'md',
  title,
}: NavIconTileProps) {
  const { isDark } = useTheme()
  const { icon, activeBorder } = getSectionNavStyles(sectionKey, isDark)
  const { bg, fg = '#ffffff' } = icon

  const dim = size === 'sm' ? 'h-7 w-7' : 'h-8 w-8'
  const iconSize = size === 'sm' ? 14 : 16

  return (
    <span
      title={title}
      className={cn(
        'flex shrink-0 items-center justify-center rounded-lg transition-all',
        dim,
        isDark ? 'shadow-none' : 'shadow-sm',
      )}
      style={{
        backgroundColor: bg,
        ...(isActive
          ? { boxShadow: `0 0 0 2px var(--bg-sidebar), 0 0 0 4px ${activeBorder}` }
          : {}),
      }}
      aria-hidden={title ? undefined : true}
    >
      <Icon size={iconSize} strokeWidth={2} style={{ color: fg }} />
    </span>
  )
}
